const faqs = [
  {
    question: "Where is Mahabharat Anubhav Kendra located?",
    answer:
      "It is located at Jyotisar, Kurukshetra, around 6 km from Kurukshetra Railway Station.",
  },
  {
    question: "How can I reach the Kendra?",
    answer:
      "You can reach by private vehicle, taxi, or public bus. The nearest stop is Jyotisar Bus Stand (150 m away).",
  },
  {
    question: "Is parking available?",
    answer: "Yes, parking facilities are available for visitors.",
  },
  {
    question: "Is the museum wheelchair accessible?",
    answer:
      "Yes, wheelchair assistance can be provided in specific situations. Visitors may request support at the venue.",
  },
  {
    question: "What are the opening days?",
    answer:
      "The museum is open Tuesday to Sunday and closed on Mondays.",
  },
  {
    question: "What are the ticket timings?",
    answer: "First ticket: 10:00 AM. Last ticket: 3:40 PM.",
  },
  {
    question: "How long does the visit take?",
    answer:
      "The complete experience takes approximately 2–2.5 hours.",
  },
  {
    question: "Is the Virat Swaroop show included in the ticket?",
    answer: "Yes, it is complimentary with the museum ticket.",
  },
  {
    question: "Are tickets required for children?",
    answer: "No ticket is required for children below 5 years.",
  },
  {
    question: "How can I buy tickets?",
    answer:
      "Tickets can be purchased online at jyotisar.haryanatourism.co.in or offline at the Jyotisar ticket counter.",
  },
  {
    question: "Is photography and videography allowed inside the museum?",
    answer:
      "Yes, photography and videography are allowed inside the museum.",
  },
  {
    question: "Is there a cloakroom or baggage storage facility?",
    answer:
      "Yes, a cloakroom facility is available. Visitors are advised not to carry heavy bags and to bring only essential items inside the museum.",
  },
  {
    question: "Are food and beverages allowed inside the museum?",
    answer:
      "No, food and beverages are not allowed inside the museum premises.",
  },
  {
    question: "Are washrooms available at the Kendra?",
    answer: "Yes, washroom facilities are available for visitors.",
  },
  {
    question: "Is an audio guide available for visitors?",
    answer:
      "Yes, an audio guide is available. Visitors can avail the audio guide by submitting a valid physical ID at the venue.",
  },
];

export default faqs;
